function handleRequestResponseError(error) {
  if (error.response) {
    // server responded with a status code after a request
    return error;
  } else if (error.request) {
    // No response was received
    return handleRequestErrors(error);
  } else {
    return error;
    // Other stuff happened
  }
}
const handleRequestErrors = (error) =>{
  if(error.code ==='ECONNABORTED'){ //handle timeouts
    error['userErrorMessage'] = "Looks like the server is taking too long to respond";
    return error;
  }
  return error;
}
export default handleRequestResponseError;


// WEBPACK FOOTER //
// ./src/common/handleRequestResponseError.js